import { render } from "./mvt-commentsuggest.vue?vue&type=template&id=50ed6357"
import script from "./mvt-commentsuggest.js?vue&type=script&lang=js"
export * from "./mvt-commentsuggest.js?vue&type=script&lang=js"

import "./mvt-commentsuggest.vue?vue&type=style&index=0&id=50ed6357&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__